import { render, staticRenderFns } from "./DrawingsView.vue?vue&type=template&id=dd68d3e0"
import script from "./DrawingsView.vue?vue&type=script&lang=js"
export * from "./DrawingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports